
module.config(function($stateProvider, TagUrl, moment, AffnetReportDefinitions) {

    var currentYear = moment().year(),

        programUrl = new TagUrl()
            .addTagType('participant')
            .setTagDefault('year', [currentYear.toString()]),

        fieldUrl = new TagUrl()
            .addTagTypes(['participant', 'program', 'location'])
            .setTagDefault('year', currentYear.toString())
            .setTagDefault('affiliation', 'all');

    function affnetBaseController($scope, $timeout, AffnetReportDefinitions,
                                  permissions) {
        var lastParams;
        $scope.definitions = AffnetReportDefinitions;
        $scope.viewCJ = permissions.viewCriminalJustice;

        $scope.refresh = function(params) {
            $timeout(function() {
                lastParams = params;
                $scope.$broadcast('tagRefresh', params);
            });
        };

        $scope.triggerRefresh = function() {
            // Don't actually refresh until refresh has been called once;
            // This prevents double requests on initial page load.
            if (angular.isDefined(lastParams)) {
                $scope.refresh(lastParams);
            }
        };

        $scope.$on('requestTagParams', $scope.triggerRefresh);
    }

    function AffnetIndexController($scope, AffnetReportDefinitions) {
        $scope.viewDetails = (!$scope.program || $scope.permissions.viewStudents);
        $scope.triggerRefresh();
        $scope.$on('tagRefresh', function(event, params) {
            $scope.reportYear = getReportYear(params.year);
        });
    }

    $stateProvider.state('reports.affnet', {
        url: fieldUrl.buildUrl('/affnet'),
        params: fieldUrl.params,
        abstract: true,
        reloadOnSearch: false,
        templateUrl: 'reports/affnet/base',
        permission: 'viewReports',
        data: {tagUrl: fieldUrl},
        controller: affnetBaseController,
    });

    $stateProvider.state('reports.affnet.index', {
        url: '',
        reloadOnSearch: false,
        templateUrl: 'reports/affnet/index',
        data: {reportName: 'index'},
        controller: AffnetIndexController,
    });


    $stateProvider.state('reports.affnet.details', {
        url: '/:reportName?{page}&{sort}&{direction}',
        reloadOnSearch: false,
        templateUrl: function($stateParams) {
            return (AffnetReportDefinitions[$stateParams.reportName] &&
                    AffnetReportDefinitions[$stateParams.reportName].programTemplate) ||
                   'reports/affnet/programsBase';
        },
        resolve: {
            reports: function($stateParams, AffnetReports) {
                return AffnetReports.forMetric($stateParams.reportName,
                                               ['details', 'summary'])
            }
        },
        controller: function($scope, $stateParams, reports) {
            $scope.details = reports.details;
            $scope.summary = reports.summary;
            $scope.detailState = 'program.reports.affnet.details';
            if ($stateParams.reportName === 'recidivism' && !$scope.viewCriminalJustice) {
                $scope.detailState = 'program.reports.affnet.index';
            }

            $scope.triggerRefresh();
            $scope.$on('tagRefresh', function(event, params) {
                reports.update(params);
            });


            $scope.getParams = function(program) {
                var params = angular.copy($scope.details.params);
                params.slug = program.slug;
                params.reportName = $stateParams.reportName;
                return params;
            }
        },
    });

    $stateProvider.state('program.reports.affnet', {
        url: programUrl.buildUrl('/affnet'),
        params: programUrl.params,
        abstract: true,
        reloadOnSearch: false,
        templateUrl: 'reports/affnet/base',
        permission: 'viewReports',
        data: {tagUrl: programUrl},
        controller: affnetBaseController,
    });

    $stateProvider.state('program.reports.affnet.index', {
        url: '',
        reloadOnSearch: false,
        templateUrl: 'reports/affnet/index',
        data: {reportName: 'index'},
        controller: AffnetIndexController,
    });

    $stateProvider.state('program.reports.affnet.details', {
        url: '/:reportName?{page}&{sort}&{direction}',
        reloadOnSearch: false,
        templateUrl: 'reports/affnet/studentsBase',
        resolve: {
            reports: function($stateParams, AffnetReports, program) {
                return AffnetReports.forMetric($stateParams.reportName,
                                               ['students', 'summary'],
                                               program);
            }
        },
        controller: function($scope, $stateParams, reports) {
            $scope.students = reports.students;
            $scope.summary = reports.summary;

            $scope.triggerRefresh();
            $scope.$on('tagRefresh', function(event, params) {
                reports.update(params);
            });
        },
    });
});


module.directive('litnumStudentRow', function() {
    return {
        restrict: 'A',
        templateUrl: 'reports/affnet/litnumStudentRow',
        scope: {student: '=litnumStudentRow'},
        link: function(scope) {
            scope.$watch('student', update, true);
            function update(student) {
                var bothInProgress = !(student.reading_upper || student.math_upper);

                scope.showEither = student.numerator ||
                    !(student.math_upper || student.reading_upper);

                scope.showMath = (student.math_numerator ||
                                  (!student.math_upper && !bothInProgress) ||
                                  student.math_lower > 10);

                scope.showReading = (student.reading_numerator ||
                                     (!student.reading_upper && !bothInProgress) ||
                                     student.reading_lower > 10);

                scope.eitherIcon = student.numerator ? 'fa-check' : 'fa-ellipsis-h';
                scope.mathIcon = student.math_numerator ? 'fa-caret-up' : 'fa-ellipsis-h';
                scope.readingIcon = student.reading_numerator ? 'fa-caret-up' : 'fa-ellipsis-h';
            }
        }
    };
});

module.directive('litnumDescription', function() {
    return {
        restrict: 'E',
        templateUrl: 'reports/affnet/litnumDescription',
        scope: {student: '=', test: '@'},
        link: function(scope) {
            scope.label = scope.test[0].toUpperCase() + scope.test.substr(1);

            function proxy(name) {
                var key = scope.test + "_" + name;
                Object.defineProperty(scope, name, {
                    get: function() { return scope.student[key]; },
                });
            }

            proxy('lower');
            proxy('upper');
            proxy('gain');
        }
    };
});

var reportNames = {
    undefined: 'Affiliated Network Measures',
    hse: 'High School Equivalency / Diploma',
    placement: 'Placement',
    certification: 'Certification',
    litnum: 'Literacy / Numeracy',
};


function getReportYear(years) {
    years = angular.isArray(years) ? years : [];
    if (years.length === 1) {
        return parseInt(years[0]);
    }
    return undefined;
}

function _formatReportYear(start, end) {
    return start === end ? start : start + ' - '  + end;
}

